export enum RoutesHeaderEnum {
  homepage = '/',
  energia = '/energia',
  allianzPay = '/allianzPay',
}
export enum HeaderEnum {
  homepage = 'header',
  energia = 'header.energy',
  allianzPay = 'header.allianzPay',
}
export enum HeroEnum {
  homepage = 'header',
  energia = 'header.energy',
}
